import { useState } from "react";
import { useTranslation } from "react-i18next";
import DialogFormPanel from "../../../../../../shared/components/panel/DialogFormPanel";
import ObjectivesTrackerEditTriggerButton from "../detail/ObjectivesTrackerEditTriggerButton";
import EditSubgoalForm from "./EditSubgoalForm";

const EditSubgoalDialog = ({ onSubmitHandler, selectables, subgoal }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = (values) => {
    setIsOpen(false);
    onSubmitHandler(values);
  };

  return (
    <DialogFormPanel
      trigger={<ObjectivesTrackerEditTriggerButton />}
      title={t("objectivesTracker.editSubgoalForm.title")}
      description={t("objectivesTracker.editSubgoalForm.description", {
        name: subgoal?.dimension?.name,
        value: subgoal?.dimension?.value,
      })}
      content={
        <EditSubgoalForm
          onSubmitHandler={onSubmit}
          selectables={selectables}
          subgoal={subgoal}
        />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default EditSubgoalDialog;
